export const RIGHT_SLEAVE_DROPDOWN_VALUES = {
    "Right Shoulder": [],
    "Right Middle Sleeve": ["Right Shoulder"],
    "Right Lower Sleeve": ["Right Shoulder", "Right Middle Sleeve",],
    "Right Bottom of Sleeve": ["Right Shoulder", "Right Middle Sleeve", "Right Lower Sleeve"]
}

export const LEFT_SLEAVE_DROPDOWN_VALUES = {
    "Left Shoulder": [],
    "Left Middle Sleeve": ["Left Shoulder"],
    "Left Lower Sleeve": ["Left Shoulder", "Left Middle Sleeve",],
    "Left Bottom of Sleeve": ["Left Shoulder", "Left Middle Sleeve", "Left Lower Sleeve"]
}